module.exports = __webpack_public_path__ + "img/ctrl-h-stub-mid-0.3522894c.svg";